module.exports = __webpack_public_path__ + "img/PilotageChart.69a5c5c5.png";